import { useState, useEffect } from "react";
import {Button, FormHelperText} from "@mui/material";
import {fni18n} from "../../services/commonService";

//MUI
import {Alert,Box,Checkbox,Container,Divider,FormControl,FormControlLabel,Grid,InputLabel,MenuItem,Paper,Select,Stack,TextField,Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DownloadForOfflineSharpIcon from "@mui/icons-material/DownloadForOfflineSharp";

function setIcon(icon){

  if(icon==='Search'){
   return( <SearchIcon/>);
  }
  else if(icon==='Down'){
   return(<DownloadForOfflineSharpIcon/>);
  }
  
  return(<></>);
};

const USelectBox = (props) => {  
  const items = props.items;
  const defaultValue = props.defaultValue || "ALL";
  const firstValue = props.defaultValue?"Select":"ALL";
  const disabled = props.defaultValue?true:false;
  const [value, setValue] = useState(defaultValue);
  const id = props.id;
  const name = props.name;
  const label = props.label;
  const [isReadOnly, setIsReadOnly] = useState(false);

  // useEffect(()=>{
  //   if (items.length === 1 && items[0].cd) {
  //     setValue(items[0].cd)
  //     setIsReadOnly(true)
  //   }
  // }, [items])
  
  useEffect(()=>{
    setValue(defaultValue)
  }, [defaultValue])

  const onhandleChange = (event) => {
    setValue(event.target.value);
    props.onItemChange(event);
  }  

  return(
    <FormControl sx={{ minWidth: 191}} size="small">
    <InputLabel id={id}>{label}</InputLabel>
        <Select
            id={id}
            label={label}
            name={name}
            onChange={onhandleChange}
            value={value}
            readOnly={isReadOnly}
            sx={{fontSize: '13px'}}
        >
        <MenuItem disabled={disabled} value={firstValue}>
          <em>{firstValue}</em>
        </MenuItem>
          
        {items && items.map((item, i) => (
            <MenuItem key={`menuitem-${i}`} value={item.cd||''}>
              {item.name||''}
            </MenuItem>
        ))}
        </Select>
    </FormControl>
  );
};
export default USelectBox;